const flaggedContentIT = {
    "view": {
        "form": {
            "button": {
                "viewDetails": "Visualizza Dettagli"
            },
            "message": {
                "releaseHasBeenAddedToWhitelist": "La release <strong>{{releaseName}}</strong> è stata aggiunta alla whitelist.",
                "releaseHasFlaggedContent": "La release <strong>{{releaseName}}</strong> contiene tracce segnalate. Si applica una tariffa di <strong>15 €</strong> per traccia segnalata per consegnarla a <strong>Spotify</strong>.<br/><br/> Clicca il pulsante qui sotto per completare il pagamento e continuare."
            },
            "modal": {
                "header": {
                    "titleFlaggedTracksDetails": "Dettagli Tracce Segnalate",
                    "titleFlaggedTrackPayment": "Pagamento Whitelisting Spotify"
                },
                "body": {
                    "table": {
                        "title": "Le seguenti tracce sono state segnalate. Si prega di rivedere i dettagli qui sotto:",
                        "column": {
                            "name": "Nome Traccia",
                            "flaggedArtist": "Artista Segnalato",
                            "payableAmount": "Importo Pagabile",
                            "paymentStatus": "Stato Pagamento"
                        },
                        "label": {
                            "payableAmount": "15 €",
                            "paid": "PAGATO",
                            "pending": "IN ATTESA",
                        },
                    },
                    "label": {
                        "processingPayment": "Elaborazione Pagamento...",
                        "paymentSuccessful": "Pagamento Riuscito!",
                        "paymentFailed": "Pagamento Fallito!"
                    },
                    "message": {
                        "totalPayableAmount": "Per completare la consegna della tua release a <strong>Spotify</strong>, è richiesto un deposito rimborsabile di <strong>{{totalAmount}} €</strong>. Si prega di accettare i termini qui sotto e cliccare il pulsante <strong>Procedi</strong> per effettuare il pagamento.",
                        "escrowAmountAgreement": "Accetto e riconosco che un importo di deposito di <strong>{{totalAmount}} €</strong> sarà depositato da me. Questo importo sarà trattenuto fino alla <strong>fine dell'abbonamento</strong> e, a condizione che non sorgano problemi, mi sarà restituito alla fine di questo periodo. Tuttavia, se durante questo periodo violerò i termini di questo accordo, l'importo del deposito sarà applicato alla fattura in sospeso e non sarà rimborsato. Procedendo, affermo la mia comprensione e accettazione di queste condizioni.",
                        "escrowPaymentRejected": "Non accetto i termini di pagamento del deposito e, di conseguenza, riconosco che la mia release <strong>{{releaseName}}</strong> <strong>non sarà distribuita su Spotify</strong>.",
                        "consentRecordedSuccessfully": "Consenso Registrato con Successo!"
                    }
                },
                "button": {
                    "proceed": "Procedi"
                }
            }
        }
    }
}

export default flaggedContentIT;